import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useMemo } from 'react';
import DSPopover, { usePopoverProviderState } from '@elliemae/ds-popover';

var TruncatedTooltipContext = /*#__PURE__*/React.createContext();
var Provider = TruncatedTooltipContext.Provider;

function TooltipTextProvider(_ref) {
  var children = _ref.children,
      _ref$tooltipDelay = _ref.tooltipDelay,
      tooltipDelay = _ref$tooltipDelay === void 0 ? 200 : _ref$tooltipDelay,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      tooltipOptions = _objectWithoutProperties(_ref, ["children", "tooltipDelay", "placement"]);

  var _usePopoverProviderSt = usePopoverProviderState({
    delay: tooltipDelay
  }),
      showTooltip = _usePopoverProviderSt.show,
      hideTooltip = _usePopoverProviderSt.hide,
      tooltipState = _usePopoverProviderSt.state;

  var _useState = useState(110),
      _useState2 = _slicedToArray(_useState, 2),
      zIndex = _useState2[0],
      setZIndex = _useState2[1];

  var value = useMemo(function () {
    return {
      showTooltip: showTooltip,
      hideTooltip: hideTooltip,
      setZIndex: setZIndex
    };
  }, []);
  return /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, children, tooltipState.visible ? /*#__PURE__*/React.createElement(DSPopover, _extends({
    boundaries: "window",
    placement: placement,
    showArrow: true
  }, tooltipOptions, tooltipState.options || {}, {
    content: tooltipState.value,
    referenceEl: tooltipState.reference,
    style: {
      pointerEvents: 'none',
      zIndex: zIndex
    },
    visible: tooltipState.visible
  })) : null);
}

TooltipTextProvider.propTypes = {};
TooltipTextProvider.defaultProps = {};

export default TooltipTextProvider;
export { TooltipTextProvider, TruncatedTooltipContext };
//# sourceMappingURL=TooltipTextProvider.js.map
